export const Foundation = {
  borderRadius: '11px',
  cardRadius: '25px',
  btnShadow: '0px 2px 9px rgba(0, 0, 0, 0.1)',
  btnBorderWidth: '2px',
  smallBorderRadius: '4px',
  mainPadding: '55px',
}
